/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PingWebhookGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type PingWebhookRequest = {
  webhookID: string;
};

export type PingWebhookResponse = {
  headers: { [k: string]: Array<string> };
  result: components.PingResponse;
};

/** @internal */
export const PingWebhookGlobals$inboundSchema: z.ZodType<
  PingWebhookGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type PingWebhookGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const PingWebhookGlobals$outboundSchema: z.ZodType<
  PingWebhookGlobals$Outbound,
  z.ZodTypeDef,
  PingWebhookGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function pingWebhookGlobalsToJSON(
  pingWebhookGlobals: PingWebhookGlobals,
): string {
  return JSON.stringify(
    PingWebhookGlobals$outboundSchema.parse(pingWebhookGlobals),
  );
}
export function pingWebhookGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<PingWebhookGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PingWebhookGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PingWebhookGlobals' from JSON`,
  );
}

/** @internal */
export const PingWebhookRequest$inboundSchema: z.ZodType<
  PingWebhookRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  webhookID: z.string(),
});
/** @internal */
export type PingWebhookRequest$Outbound = {
  webhookID: string;
};

/** @internal */
export const PingWebhookRequest$outboundSchema: z.ZodType<
  PingWebhookRequest$Outbound,
  z.ZodTypeDef,
  PingWebhookRequest
> = z.object({
  webhookID: z.string(),
});

export function pingWebhookRequestToJSON(
  pingWebhookRequest: PingWebhookRequest,
): string {
  return JSON.stringify(
    PingWebhookRequest$outboundSchema.parse(pingWebhookRequest),
  );
}
export function pingWebhookRequestFromJSON(
  jsonString: string,
): SafeParseResult<PingWebhookRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PingWebhookRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PingWebhookRequest' from JSON`,
  );
}

/** @internal */
export const PingWebhookResponse$inboundSchema: z.ZodType<
  PingWebhookResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.PingResponse$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type PingWebhookResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.PingResponse$Outbound;
};

/** @internal */
export const PingWebhookResponse$outboundSchema: z.ZodType<
  PingWebhookResponse$Outbound,
  z.ZodTypeDef,
  PingWebhookResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.PingResponse$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function pingWebhookResponseToJSON(
  pingWebhookResponse: PingWebhookResponse,
): string {
  return JSON.stringify(
    PingWebhookResponse$outboundSchema.parse(pingWebhookResponse),
  );
}
export function pingWebhookResponseFromJSON(
  jsonString: string,
): SafeParseResult<PingWebhookResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PingWebhookResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PingWebhookResponse' from JSON`,
  );
}
